/* Glob Mops homepage: finder tabs and add-to-cart for the gm-* sections. */
(function () {
  if (window.__gmHome) return;
  window.__gmHome = true;

  var toastEl, toastTimer;
  function toast(msg, href) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'gm-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    if (href) {
      var a = document.createElement('a');
      a.href = href;
      a.textContent = 'View cart';
      toastEl.appendChild(a);
    }
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 3500);
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-gm-tab]');
    if (!tab) return;
    var root = tab.closest('.gm-finder');
    root.querySelectorAll('[data-gm-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', b === tab ? 'true' : 'false');
    });
    root.querySelectorAll('[data-gm-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-gm-panel') !== tab.getAttribute('data-gm-tab');
    });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-gm-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var name = form.getAttribute('data-gm-name') || 'Item';
    // Reuse the theme's own cart notification (or drawer) when it is on the page.
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var data = new FormData(form);
    if (cart && cart.getSectionsToRender) {
      data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      data.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }
    btn.disabled = true;
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          toast(res.description || res.message || 'Could not add to cart.');
          return;
        }
        var shown = false;
        if (cart && cart.renderContents && res.sections) {
          try { cart.renderContents(res); shown = true; } catch (err) {}
        }
        if (!shown) toast('Added ' + name + '.', (window.routes && window.routes.cart_url) || '/cart');
      })
      .catch(function () { form.submit(); })
      .finally(function () { btn.disabled = false; });
  });
})();
